import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const getDefaultState = () => ({
  general: {
    api_host: "/api",
    api_private_host: 'https://10.30.2.4/api',
    //api_host: "http://10.30.2.4/api",
    debug_mode: false,
    active_connections: 0,
    current_user_list: [],
    dialogs: [],
    global_search: '',
    settings: {
      shop_gbs_order_inform: null,
      shop_gbs_cancel_inform: null
    }
  },
  user: {
    user_path: '',
    id: null,
    authToken: null,
    displayName: '',
    mail: '',
    sn: '',
    cn: '',
    givenName: '',
    pms: []
  },
  push_notifications: {
    list: []
  },
  device: {
    master_time: "--:--",
    display_name: "",
    issi: "5236014",
    opta: "",
    cellID: 0,
    rssi: "99",
    selected_GSSI_name: ""
  },
  engines: {
    engines: []
  },
  status_tableau: {
    stations_list: null,
    stations: []
  },
  ticketsystem: {
    users: [],
    cis: [],
    tickets: [],
    workflows: [],

    ci_logs: [],
    ci_logs_by_ci: {},
    ci_logs_ids: {},

  },
  message_center: {
    messages: []
  },
  machine_viewer: {
    locations: null
  },
  phonebook: {
    last_updated: null,
    book: null
  },
  kentix: {
    alarmgroups_status: {},
    users: null,
    devices: null,
    devices_lut: {},
    levelprofiles: null,
    levelprofiles_lut: {},
    access_log: null
  },
  shop: {
    products: null,
    inventory: null,
    allocations: null
  },
  sirenen: {
    sirenen: {}
  },
  appointments: {
    all: null,
    free: null
  },
});

export default new Vuex.Store({
  state: getDefaultState(),
  getters: {
    inPrivateNet(state){
      return state.engines.engines.length > 0
    },
    get_cis_without_deleted(state){
      return state.ticketsystem.cis.filter(obj => {return obj.state !== 'DELETED'})
    },
    get_ci: (state) => (id) => {
      let ci = state.ticketsystem.cis.find(obj => {return obj.id === id})
      return ci
    },
    get_ticket: (state) => (id) => {
      let ticket = state.ticketsystem.tickets.find(obj => {return obj.id === id})
      return ticket
    },
    get_station: (state) => (display_name) => {
      let station = state.status_tableau.stations.find(obj => {return obj.display_name === display_name})
      if(typeof station === "undefined"){
        return null
      }
      else {
        return station
      }
    },
    get_engine: (state) => (issi) => {
      let engine = state.engines.engines.find(obj => {return obj.issi === issi})
      if(typeof engine === "undefined"){
        return null
      }
      else {
        return engine
      }
    },
    has_permission: (state) => (necessary_pms_array) => {
      for(let pms_index in necessary_pms_array){
        let pms = necessary_pms_array[pms_index]
        if (state.user.pms.includes('SFW_ELOCOM_' + pms)){
          return true
        }
      }
      return false
    },
    get_kentix_device: (state) => (device_id) => {
      return state.kentix.devices_lut[device_id]
    },
    get_kentix_levelprofile: (state) => (levelprofile_id) => {
      return state.kentix.levelprofiles_lut[levelprofile_id]
    }
  },
  mutations: {
    login(state, authToken) {
      this.state.user.authToken = authToken
      localStorage.setItem("authToken", authToken)
      this.dispatch('update', { context: '/users/me', method: 'POST'})
    },
    reset_store(state) {
      Object.assign(state, getDefaultState());
    },
    expand_login(state, authToken) {
      this.state.user.authToken = authToken
      localStorage.setItem("authToken", authToken)
    },
    logout (state) {
      state.user.user_path = ''
      state.user.id = null,
      state.user.authToken = null,
      state.user.displayName = '',
      state.user.mail = '',
      state.user.sn = '',
      state.user.cn = ''
      state.user.givenName = ''
      state.user.pms = []
      this.commit('reset_store')
    },
    add_push_notification(state, notification){
      console.log(notification)
      if(!('live_time' in notification)){
        notification["live_time"] = 30001
      }
      this.state.push_notifications.list.push(notification)
      let thiis = this
      setTimeout( function() {
        if (thiis.state.push_notifications.list.includes(notification)){
          thiis.commit('remove_push_notification', notification)
        }
      }, notification['live_time']);
    },
    remove_push_notification(state, notification){
      const index = this.state.push_notifications.list.indexOf(notification);
      this.state.push_notifications.list.splice(index, 1);
    },
    remove_workflow(state, id){
      state.ticketsystem.workflows = state.ticketsystem.workflows.filter(w => w.id !== id)
    },
    process_input(state, payload){
      //GENERAL
      if("general" in payload) {
        this.state.general.active_connections = payload.general.active_connections
        this.state.general.current_user_list = payload.general.current_user_list
      }
      if("setting" in payload) {
        let setting = payload.setting
        this.state.general.settings[setting.key] = setting.value
      }
      //USER
      if("user_me" in payload) {
        this.state.user.user_path = payload.user_me.user_path
        this.state.user.id = payload.user_me.id
        this.state.user.displayName = payload.user_me.displayName
        this.state.user.mail = payload.user_me.mail
        this.state.user.sn = payload.user_me.sn
        this.state.user.cn = payload.user_me.cn
        this.state.user.givenName = payload.user_me.givenName
        this.state.user.pms = payload.user_me.pms
      }
      if("access_token" in payload) {
        this.commit('expand_login', payload.access_token)
      }
      //device
      if("device" in payload) {
        this.state.device.display_name = payload.device.display_name
        this.state.device.issi = payload.device.issi
        this.state.device.opta = payload.device.opta
        this.state.device.cellID = payload.device.cellID
        this.state.device.rssi = payload.device.rssi
        this.state.device.selected_GSSI_name = payload.device.selected_GSSI_name
      }
      // CMDB / CIS
      if("cis" in payload) {
        this.state.ticketsystem.cis = payload.cis
      }
      if("ci" in payload) {
        let ci = payload.ci
        this.state.ticketsystem.cis = this.state.ticketsystem.cis.filter(function(el) { return el.id != payload.ci.id; });
        this.state.ticketsystem.cis.push(ci)
      }
      const merge_ci_log = (ci_log) => {
        const ci_id = ci_log.ci_id
        const log_id = ci_log.id
        const existing = this.state.ticketsystem.ci_logs_ids[log_id]
        if (existing) {
          Object.assign(existing, ci_log)
          return
        }
        this.state.ticketsystem.ci_logs.push(ci_log)
        this.state.ticketsystem.ci_logs_ids[log_id] = ci_log
        if (!(ci_id in state.ticketsystem.ci_logs_by_ci)) {
          Vue.set(state.ticketsystem.ci_logs_by_ci, ci_id, [])
        }
        state.ticketsystem.ci_logs_by_ci[ci_id].push(ci_log)
      }
      if("ci_logs" in payload) {
        for(let index in payload.ci_logs){
          merge_ci_log(payload.ci_logs[index])
        }
      }
      if("ci_log" in payload) {
        merge_ci_log(payload.ci_log)
      }
      // Workflow-Blueprints
      if("workflows" in payload) {
        this.state.ticketsystem.workflows = payload.workflows
      }
      if("workflow" in payload) {
        let wf = payload.workflow
        this.state.ticketsystem.workflows = this.state.ticketsystem.workflows.filter(w => w.id !== wf.id)
        this.state.ticketsystem.workflows.push(wf)
      }
      // Ticketsystem
      if("tickets" in payload) {
        for(let index in payload.tickets){
          let ticket = payload.tickets[index]
          this.state.ticketsystem.tickets = this.state.ticketsystem.tickets.filter(function(el) { return el.id != ticket.id; });
          this.state.ticketsystem.tickets.push(ticket)
        }
        //this.state.ticketsystem.tickets = payload.tickets
      }
      if("ticket" in payload) {
        let ticket = payload.ticket
        this.state.ticketsystem.tickets = this.state.ticketsystem.tickets.filter(function(el) { return el.id != ticket.id; });
        this.state.ticketsystem.tickets.push(ticket)
      }
      // Users
      if("users" in payload) {
        this.state.ticketsystem.users = payload.users
      }
      if("user" in payload) {
        let user = payload.user
        this.state.ticketsystem.users = this.state.ticketsystem.users.filter(function(el) { return el.id != user.id; });
        this.state.ticketsystem.users.push(user)
      }
      // ENGINES
      if("engines" in payload) {
        this.state.engines.engines = payload.engines
      }
      if("engine" in payload) {
        let engine = payload.engine
        this.state.engines.engines = this.state.engines.engines.filter(function(el) { return el.issi != engine.issi; });
        this.state.engines.engines.push(engine)
      }
      // STATUS TABLEAU
      if("stations" in payload) {
        this.state.status_tableau.stations = payload.stations
      }
      if("station" in payload) {
        let station = payload.station
        this.state.status_tableau.stations = this.state.status_tableau.stations.filter(function(el) { return el.display_name != payload.station.display_name; });
        this.state.status_tableau.stations.push(station)
        //if(jsObjects.find(obj => {return obj.display_name === this.display_name})){

        //}
      }
      // MESSAGE Center
      if("messages" in payload) {
        let messages = payload.messages
        this.state.message_center.messages = messages
      }
      if("message" in payload) {
        let new_message = payload.message
        for (let index in this.state.message_center.messages){
          let message = this.state.message_center.messages[index]
          if(new_message.id == message.id) {
            for(let key in new_message){
              message[key] = new_message[key]
            }
          }
        }
      }
      //phonebock
      // Machine Viewer
      if("phonebook" in payload) {
        let phonebook = payload.phonebook
        this.state.phonebook.book = phonebook.sort((a, b) => a.displayName.localeCompare(b.displayName));
      }
      if("phonebook_last_updated" in payload) {
        this.state.phonebook.last_updated = payload.phonebook_last_updated
      }
      if("vncs" in payload) {
        let vncs = payload.vncs
        this.state.machine_viewer.locations = vncs
      }
      if("vnc" in payload) {
        let new_vnc = payload.vnc
        for(let location_index in this.state.machine_viewer.locations){
          let machine = this.state.machine_viewer.locations[location_index]
          if(machine.id === new_vnc.id){
            for(let key in new_vnc){
              this.state.machine_viewer.locations[location_index][key] = new_vnc[key]
            }
          }
        }
      }
      // Shop
      if("shop_products" in payload) {
        this.state.shop.products = payload.shop_products
      }
      if("shop_inventory" in payload) {
        this.state.shop.inventory = payload.shop_inventory
      }
      if("shop_allocations" in payload) {
        this.state.shop.allocations = payload.shop_allocations
      }
      if("shop_allocation" in payload) {
        let existing = null
        let updated  = payload.shop_allocation
        for (let user of this.state.shop.allocations || []) {
          let match = user.allocations.find(a => a.id === updated.id)
          if (match) {
            existing = match
          }
          if (existing) {
            existing.state = updated.state
            existing.state_editor = updated.state_editor
            existing.state_timestamp = updated.state_timestamp
          }
        }
      }
      // Kentix
      if("alarmgroups_status" in payload) {
        this.state.kentix.alarmgroups_status = payload.alarmgroups_status
      }
      if("alarmgroup_status" in payload) {
        console.log(this.state.kentix.alarmgroups_status)
        let alarmgroup_status = payload.alarmgroup_status
        let id = alarmgroup_status.id
        this.state.kentix.alarmgroups_status[id] = [alarmgroup_status.status, alarmgroup_status.timestamp]
        console.log(this.state.kentix.alarmgroups_status)
      }
      if("kentix_user" in payload){
        let updated_user = payload.kentix_user
        for(let index in this.state.kentix.users){
          let user = this.state.kentix.users[index]
          if(user['kentix_id'] === updated_user['kentix_id']){
            for(let key in updated_user){
              this.state.kentix.users[index][key] = updated_user[key]
            }

          }
        }
      }
      if("kentix_users" in payload){
        this.state.kentix.users = payload.kentix_users
      }
      if("kentix_devices" in payload){
        this.state.kentix.devices = payload.kentix_devices
        for(let i in payload.kentix_devices){
          this.state.kentix.devices_lut[payload.kentix_devices[i].id] = payload.kentix_devices[i]
        }
      }
      if("kentix_levelprofiles" in payload){
        this.state.kentix.levelprofiles = payload.kentix_levelprofiles
        for(let i in payload.kentix_levelprofiles){
          this.state.kentix.levelprofiles_lut[payload.kentix_levelprofiles[i].id] = payload.kentix_levelprofiles[i]
        }
      }
      if("kentix_access_log" in payload){
        this.state.kentix.access_log = payload.kentix_access_log
      }
      // SIRENEN
      if("sirenen" in payload){
        if(Object.keys(this.state.sirenen.sirenen).length === 0){
          this.state.sirenen.sirenen = payload.sirenen
        }
        else {
          for(let index in payload.sirenen){
            let sirene = payload.sirenen[index]
            this.commit('process_input', {'sirene' : sirene})
          }
        }
      }
      if("sirene" in payload){
        let sirene = payload.sirene
        let id = sirene.id
        for(let index in this.state.sirenen.sirenen){
          let current_sirene = this.state.sirenen.sirenen[index]
          if(current_sirene.id === id){
            current_sirene.name = sirene.name
            current_sirene.name_safus = sirene.name_safus
            current_sirene.address = sirene.address
            current_sirene.phonenumber = sirene.phonenumber
            current_sirene.description = sirene.description
            current_sirene.safi_timestamp = sirene.safi_timestamp
            current_sirene.safi_ActionNumber = sirene.safi_ActionNumber
            current_sirene.safi_AccumulatorVoltage = sirene.safi_AccumulatorVoltage
            current_sirene.safi_Temperature = sirene.safi_Temperature
            current_sirene.safi_InvalidPathsOfAmplifiers = sirene.safi_InvalidPathsOfAmplifiers
            current_sirene.safi_TestValid = sirene.safi_TestValid
            current_sirene.safi_Mains = sirene.safi_Mains

            current_sirene.is_awaiting_response = sirene.is_awaiting_response
            current_sirene.isNotificationsOn = sirene.isNotificationsOn
          }
        }
      }
      // Appointsments
      if("appointments" in payload){
        this.state.appointments.all = payload.appointments
      }
      if("appointments_free" in payload){
        this.state.appointments.free = payload.appointments_free
      }
    }
  },
  actions: {
    update(state, payload) {
      let query = this.state.general.api_host + payload.context;
      let headers = {
        Authorization: 'Bearer ' + this.state.user.authToken
      }
      if('payload' in payload){
        headers['Content-Type'] = 'application/json'
      }
      return fetch(query, {
        method: 'payload_type' in payload ? payload.payload_type : 'payload' in payload ? "POST" : "GET",
        headers: headers,
        body: JSON.stringify(payload.payload),
      })
        .then((response) => {
          if (response.status == 200) {
            return response.text();
          } else if (response.status == 400 || response.status == 401) {
            this.commit('logout')
            return "{}"
          } else if (response.status == 403) {
            console.log(response.text())
            return "{}"
          } else {
            throw new Error(response.message);
          }
        })
        //.then(response => response.text())
        .then((response) => decodeURIComponent(response))
        .then((response) => JSON.parse(response))
        .then((data) => {
          if (!payload.skip_process) {
            this.commit('process_input', data)
          }
          return data
        })
        .catch((error) => {
          console.log(error)
        });
    }
  },
  modules: {},
});
